import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 7v10l5 3l5 -3m0 -4v-9l-5 3l-2.496 -1.497","key":"svg-0"}],["path",{"d":"M3 3l18 18","key":"svg-1"}]]

/**
 * IconBadgeOff
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItYmFkZ2Utb2ZmIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik03IDd2MTBsNSAzbDUgLTNtMCAtNHYtOWwtNSAzbC0yLjQ5NiAtMS40OTciIC8+CiAgPHBhdGggZD0iTTMgM2wxOCAxOCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/badge-off
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconBadgeOff = createReactComponent('outline', 'badge-off', 'BadgeOff', __iconNode);

export default IconBadgeOff;